import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

const MuiTypography = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      letterSpacing: '-0.3px',
      '& a': {
        textDecoration: 'underline',
        color: 'inherit'
      }
    })
  }
} as Components['MuiTypography'];

export default MuiTypography;
